<p-table
  [value]="items"
  [loading]="localLoading()"
>
  <ng-template #header>
    <tr>
      @for (column of columns; track $index) {
        <th
          [class]="column.align + ' text-sm'"
          [ngClass]="{ 'cursor-pointer': column.sortable }"
          (click)="column.sortable && sort(column.slug)"
        >
          {{ column.label }}
          @if (pageControl.orderField === column.slug) {
            @if (pageControl.order === order.ASC) {
              <i class="fa-solid fa-arrow-up"></i>
            }
            @if (pageControl.order === order.DESC) {
              <i class="fa-solid fa-arrow-down"></i>
            }
          }
        </th>
      }
    </tr>
  </ng-template>
  <ng-template #emptymessage>
    <tr>
      <td colspan="8" class="text-center">
        <div class="h-44 p-4 text-zinc-500">
          <ng-lottie [options]="emptyLottieOptions" />
          Nenhum registro encontrado.
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template #body let-item>
    <tr>
      <td>{{ item?.name || '---' }}</td>

      <td>{{ item?.email || '---' }}</td>

      <td>{{ item?.phone || '---' }}</td>

      <td>
        <div
          class="px-2 py-1 text-sm rounded-sm bg-gray-100 w-fit font-semibold"
          [ngClass]="{
            'text-emerald-600': item.status === userStatus.ACTIVE,
            'text-rose-600': item.status === userStatus.INACTIVE,
            'text-amber-600': item.status === userStatus.PENDING
          }"
        >
          {{ item?.status | userStatus }}
        </div>
      </td>

      <td>{{ item?.created_at | date: 'dd/MM/y' }}</td>

      <td>{{ item?.roles[0]?.name | role }}</td>

      <td>
        <p-confirmpopup />
        <p-menu #actions [model]="menuItems" [popup]="true" appendTo="body">
          <ng-template #item let-option>
            @if (!option.queryParams.show || option.queryParams.show(item)) {
              <a
                class="flex items-center px-4 py-2 cursor-pointer group"
                (click)="actions.hide(); option.action(item, $event); $event.stopPropagation()"
              >
                <i [class]="option.icon"></i>
                <span class="ml-2">{{ option.label }}</span>
              </a>
            }
          </ng-template>
        </p-menu>
        <p-button (click)="actions.show($event)" rounded variant="text">
          <i class="fa-solid fa-ellipsis-vertical py-1"></i>
        </p-button>
      </td>
    </tr>
  </ng-template>
 <ng-template #footer>
   <tr>
     <td colspan="7">
        <div class="w-full flex justify-end">
          <p-paginator
            (onPageChange)="onPageChange($event)"
            [rows]="pageControl.take"
            [totalRecords]="pageControl.itemCount"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[10, 25, 50]"
            currentPageReportTemplate="{first} - {last} de {totalRecords}"
            appendTo="body"
          />
        </div>
     </td>
   </tr>
 </ng-template>
</p-table>
